// extracted by mini-css-extract-plugin
export default {"mobileAndText":"page3_mobileAndText__zu46J","newsletter":"page3_newsletter__ikHBf"};